import { TableRow as Mui4TableRow, TableRowProps as Mui4TableRowProps } from '@material-ui/core'
import { default as Mui5TableRow } from '@mui/material/TableRow'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsTableVersion } from './Table'

export type TableRowProps = Mui4TableRowProps
/** @deprecated Use TableRowProps */
export type OsTableRowProps = TableRowProps

export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>((props, ref) => {
  const version = useComponentVersion('table')
  switch (version) {
    case OsTableVersion.V2:
      return <Mui5TableRow ref={ref} {...props} />

    default:
      return <Mui4TableRow ref={ref} {...props} />
  }
})
